import { FC, PropsWithChildren, ReactNode } from 'react';

import { TextTooltip } from 'components/ui/TextTooltip';

interface INameProps {
  value: string;
  postfix?: ReactNode;
  className?: string;
}

export const Name: FC<PropsWithChildren<INameProps>> = ({
  value,
  postfix,
  className,
  children,
}) => (
  <span className="flex overflow-hidden">
    <TextTooltip
      value={value}
      classNames={{ childrenClassName: className }}
      autoShow
    >
      {children}
    </TextTooltip>
    {postfix && <>&nbsp;{postfix}</>}
  </span>
);
